import { render, staticRenderFns } from "./HomeworkStatusPill.vue?vue&type=template&id=0c519edf&scoped=true&"
import script from "./HomeworkStatusPill.vue?vue&type=script&lang=js&"
export * from "./HomeworkStatusPill.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkStatusPill.vue?vue&type=style&index=0&id=0c519edf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c519edf",
  null
  
)

export default component.exports